import type { ReactNode } from 'react';

export function BottomSheet({
  title,
  onClose,
  onBack,
  onDone,
  doneLabel = 'Hecho',
  children,
  footer,
  tall,
  className,
  /** Dock at bottom without blocking canvas (pointer-events pass through). */
  docked,
}: {
  title: string;
  onClose?: () => void;
  onBack?: () => void;
  onDone?: () => void;
  doneLabel?: string;
  children: ReactNode;
  /** Sticky CTA / actions below the scrollable body (always visible). */
  footer?: ReactNode;
  tall?: boolean;
  className?: string;
  docked?: boolean;
}) {
  const dismiss = onClose ?? onDone ?? onBack;

  return (
    <div
      className={`ox-sheet-backdrop${docked ? ' ox-sheet-docked' : ''}`}
      onClick={docked ? undefined : dismiss}
    >
      <div
        className={[
          'ox-sheet',
          tall ? 'ox-sheet-tall' : '',
          footer ? 'ox-sheet-has-footer' : '',
          className ?? '',
        ]
          .filter(Boolean)
          .join(' ')}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-label={title}
      >
        <header className="ox-sheet-header">
          {onBack ? (
            <button type="button" className="ox-sheet-link" onClick={onBack}>
              ‹ Atrás
            </button>
          ) : (
            <span className="ox-sheet-title">{title}</span>
          )}
          {onBack && <span className="ox-sheet-title-center">{title}</span>}
          {onDone ? (
            <button type="button" className="ox-sheet-done" onClick={onDone}>
              ✓ {doneLabel}
            </button>
          ) : onClose ? (
            <button type="button" className="ox-sheet-x" onClick={onClose} aria-label="Cerrar">
              ✕
            </button>
          ) : (
            <span />
          )}
        </header>
        <div className="ox-sheet-body">{children}</div>
        {footer ? <footer className="ox-sheet-footer">{footer}</footer> : null}
      </div>
    </div>
  );
}
